import React, { useState } from 'react';
import FormField from '../common/FormField';
import { formatCurrency } from '../../utils/formatters';
import { FiInfo } from 'react-icons/fi';
import './AffordabilityCalc.css';

const AffordabilityCalc = ({ task }) => {
  // Mock Data
  const [rent, setRent] = useState(12000);
  const [grossIncome, setGrossIncome] = useState(35000);
  const [netIncome, setNetIncome] = useState(25500);
  const [commitments, setCommitments] = useState(8000);

  const calculate = () => {
    const grossRatio = (rent / grossIncome) * 100;
    const netRatio = (rent / netIncome) * 100;
    const residual = netIncome - commitments - rent;
    
    let zone = 'green';
    if (grossRatio > 35 || netRatio > 50 || residual < 2000) zone = 'red';
    else if (grossRatio > 30 || netRatio > 40 || residual < 5000) zone = 'amber';

    return { grossRatio, netRatio, residual, zone };
  };

  const results = calculate();

  return (
    <div className="affordability-calc card">
      <div className="card-header">
        <h2>Affordability Assessment</h2>
      </div>
      <div className="card-body">
        <div className="disclaimer-banner">
          <FiInfo className="icon" />
          <div>
            <strong>Important Notice</strong>
            <p>This calculation is for informational guidance only. These ranges must not be used as automatic eligibility thresholds. The landlord is responsible for the final decision.</p>
          </div>
        </div>

        <div className="calc-layout">
          <div className="calc-inputs">
            <h3>Financial Inputs</h3>
            <FormField label="Monthly Rent (ZAR)" name="rent" type="number" value={rent} onChange={(e) => setRent(Number(e.target.value))} />
            <FormField label="Gross Monthly Income (Verified)" name="grossIncome" type="number" value={grossIncome} onChange={(e) => setGrossIncome(Number(e.target.value))} />
            <FormField label="Net Monthly Income (Verified)" name="netIncome" type="number" value={netIncome} onChange={(e) => setNetIncome(Number(e.target.value))} />
            <FormField label="Monthly Debt/Commitments (Declared)" name="commitments" type="number" value={commitments} onChange={(e) => setCommitments(Number(e.target.value))} />
          </div>

          <div className="calc-results">
            <h3>Calculated Indicators</h3>
            
            <div className={`result-card zone-${results.zone}`}>
              <div className="result-metric">
                <span className="metric-label">Gross Rent-to-Income</span>
                <span className="metric-value">{results.grossRatio.toFixed(1)}%</span>
              </div>
              <div className="metric-formula">Formula: Rent ÷ Gross Income</div>
            </div>

            <div className={`result-card zone-${results.zone}`}>
              <div className="result-metric">
                <span className="metric-label">Net Rent-to-Income</span>
                <span className="metric-value">{results.netRatio.toFixed(1)}%</span>
              </div>
              <div className="metric-formula">Formula: Rent ÷ Net Income</div>
            </div>

            <div className={`result-card zone-${results.zone}`}>
              <div className="result-metric">
                <span className="metric-label">Residual Amount</span>
                <span className="metric-value">{formatCurrency(results.residual)}</span>
              </div>
              <div className="metric-formula">Formula: Net Income - Commitments - Rent</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AffordabilityCalc;
